import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { INT_MODEL } from '../constant/actionTypes';

const apiEndPoint = constants.ADMIN_URL;

export const getIntelligentModel = () => (dispatch) => {
  dispatch({
    payload: [],
    type: INT_MODEL.GET.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.INT_MODEL_DATA}`)
    .then((intelligentModelResult) => {
      dispatch({
        payload: { data: intelligentModelResult.data.response },
        type: INT_MODEL.GET.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: INT_MODEL.GET.ERROR,
      });
    });
};

export const doIntelligentModelDelete = (id) => httpservice()
  .delete(`${apiEndPoint}${constants.API.INT_MODEL_DATA}/${id}`)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
